import {useMutation} from "@tanstack/react-query";

import {residentClaimService} from "../services";
import type {CompleteClaimRequest} from "../types";

export default function useResidentClaimComplete() {
  return useMutation({
    mutationFn: (body: CompleteClaimRequest) => residentClaimService.completeClaim(body),
  });
}
